var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReviewCardRightArrow(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2326 35.9096C12.7639 35.4408 12.5007 34.805 12.5007 34.1421C12.5007 33.4792 12.7639 32.8435 13.2326 32.3746L25.6076 19.9996L13.2326 7.62464C12.7772 7.15313 12.5252 6.52163 12.5309 5.86613C12.5366 5.21064 12.7996 4.58361 13.2631 4.12009C13.7266 3.65657 14.3536 3.39365 15.0091 3.38795C15.6646 3.38226 16.2961 3.63424 16.7676 4.08964L30.9101 18.2321C31.3788 18.701 31.6421 19.3367 31.6421 19.9996C31.6421 20.6625 31.3788 21.2983 30.9101 21.7671L16.7676 35.9096C16.2988 36.3783 15.663 36.6416 15.0001 36.6416C14.3372 36.6416 13.7014 36.3783 13.2326 35.9096Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReviewCardRightArrow);
export default __webpack_public_path__ + "static/media/reviewCardRightArrow.7b65977210e5935fd22f7333f12feba5.svg";
export { ForwardRef as ReactComponent };